import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { RateBucketsService } from '../rate-bucket.service';
import { RateBucket } from '../rate-bucket';
import { RateBucketsComponent } from '../rate-bucket/rate-bucket.component';
import { RateBucketCopyFormComponent } from '@app/_components/rate/rate-bucket/rate-bucket-copy-form/rate-bucket-copy-form.component';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
    selector: 'app-rateBuckets-list',
    templateUrl: './rate-bucket-list.component.html',
    styleUrls: ['./rate-bucket-list.component.css'],
    providers: [DialogService, MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RateBucketsListComponent implements OnInit {
	constructor(
		private rateBucketService: RateBucketsService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		public dialogService: DialogService
	) {
		this.statuses = rateBucketService.statuses;
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	rateBuckets: any;
	rateBucket: RateBucket;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'rateBucketId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.rateBucketId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-rateBucket-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.rateBucketService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.rateBuckets = res.data.rateBuckets;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.rateBuckets = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(rateBucket: RateBucket) {
		try {
			this.formLoading = true;
			this.rateBucketService.update(rateBucket)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.rateBuckets.map((rateBucket, i) => {
							if (rateBucket.rateBucketId === res.data.rateBucket.rateBucketId) {
								this.rateBuckets[i] = res.data.rateBucket;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(rateBucket: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(rateBucket));

			this.formLoading = true;
			this.rateBucketService.delete(rateBucket.rateBucketId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.rateBuckets.splice(this.rateBuckets.indexOf(rateBucket), 1);
						this.recordTotal = this.rateBuckets.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RateBucket ' + rateBucket.rateBucketId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RateBucket ' + rateBucket.rateBucketId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RateBucket'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateBucketsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRateBucketCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(rateBucket: RateBucket) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			rateBucket: rateBucket,
			title: 'Edit RateBucket'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RateBucketsComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRateBucketCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRateBucketCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addRateBucketCB(rateBucket: RateBucket) {
		console.log('Adding RateBucket: ' + JSON.stringify(rateBucket));
		// if we don't have a rateBuckets array yet...
		if (!this.rateBuckets) {
			this.rateBuckets = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.rateBuckets.unshift(rateBucket);

		// no idea what this is but it is required to update the array
		this.rateBuckets = [...this.rateBuckets];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateBucket ' + rateBucket.rateBucketId + ' Added', life: 3000 });
	}

	updateRateBucketCB(rateBucket: RateBucket) {
		console.log('Updating RateBucket: ' + JSON.stringify(rateBucket));
		let itemIndex = this.rateBuckets.findIndex((item: any) => item.rateBucketId === rateBucket.rateBucketId);
		this.rateBuckets[itemIndex] = rateBucket;

		// no idea what this is but it is required to update the array
		this.rateBuckets = [...this.rateBuckets];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateBucket ' + rateBucket.rateBucketId + ' Updated', life: 3000 });
	}

	deleteRateBucketCB(rateBucket: RateBucket) {
		console.log('Removing RateBucket: ' + rateBucket);
		this.rateBuckets.splice(this.rateBuckets.indexOf(rateBucket), 1);
		this.recordTotal = this.rateBuckets.length;

		// no idea what this is but it is required to update the array
		this.rateBuckets = [...this.rateBuckets];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RateBucket ' + rateBucket.rateBucketId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.rateBuckets ? this.first === (this.rateBuckets.length - this.rows) : true; }
	isFirstPage(): boolean { return this.rateBuckets ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(rateBucket: any) {
		if (rateBucket?.status) {
			const status = this.statuses.find((e: any) => e.value == rateBucket.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	/*********
		  * Copy Button
		  * made with primeng
		  */
	onOpenFormCopy(rateBucket: RateBucket) {
		const ref = this.dialogService.open(RateBucketCopyFormComponent, {
			data: {
				rateBucket: rateBucket
			},
			header: 'Copy ' + rateBucket.name + '  (#' + rateBucket.rateBucketId + ')',
			width: 'auto'
		});

		ref.onClose.subscribe((form1: any) => {
			if (form1) {
				this.copyRateBucket(form1);
			}
		});
	}

	copyRateBucket(rateBucket: RateBucket) {
		try {
			this.formLoading = true;
			this.rateBucketService.copy(rateBucket)
				.subscribe(
					res => {
						console.log('Rate-Bucket-Copy SUCCESS: ' + JSON.stringify(res));

						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: 'New Rate Bucket ' + rateBucket.name + ' created.' });
					},
					err => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
